
import BusinessLogo from "@/components/business/BusinessLogo"
import JobPageMedia from "@/components/job/jobpage/JobPageMedia"
import JobPageOverviewInfo from "@/components/job/jobpage/JobPageOverviewInfo"

import themes from "@/mixins/themes"

import { mdiClose, mdiInformationOutline } from "@mdi/js"

export default {
    name: "JobPagePreviewCard",
    components: {
        BusinessLogo,
        JobPageMedia,
        JobPageOverviewInfo,
    },
    mixins: [themes],
    provide() {
        return {
            job: () => this.job,
        }
    },
    props: {
        /** job object */
        job: {
            type: Object,
            required: true,
        },
    },
    fetch() {
        const theme = this.job.theme?.theme
        if (theme) this.setTheme(theme)
        else this.setThemeDefaultDark()
    },
    icons: { mdiClose, mdiInformationOutline },
    computed: {
        jobSections() {
            const contentBlocks = this.job.content_blocks
            if (!contentBlocks) return []
            return contentBlocks[0].data.items.map((el) => el.data)
        },
        currentMedia() {
            if (this.job.video?.is_rendered || this.job.video?.local)
                return this.job.video
            else return this.job.image
        },
        theme() {
            return this.job.theme?.theme
        },
    },
}
